import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { getDate, getShowCompletedJobs } from '../selectors';
import DateFilteringPanel from './DateFilteringPanel';

const propTypes = exact({
  date: PropTypes.object,
  showCompletedJobs: PropTypes.bool.isRequired,
});


const FormView = (props) => {
  const { date, showCompletedJobs } = props;
  return (
    <React.Fragment>
      <DateFilteringPanel initialValues={{ date, showCompletedJobs }} />
    </React.Fragment>
  );
};


FormView.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    date: getDate(state),
    showCompletedJobs: getShowCompletedJobs(state),
  };
};

const enhance = connect(mapStateToProps, {});

export default enhance(FormView);
